import { useRef } from 'react';
import * as R from 'remeda';
import { IconFolder } from '@rossum/ui/icons/tabler';
import { Skeleton, Stack, SvgIcon } from '@rossum/ui/material';

export const QueueListSkeletons = () => {
  const widths = useRef(
    [1, 2, 3, 4, 5, 6, 7].map(n => [n, R.randomInteger(200, 250)] as const)
  ).current;

  return (
    <Stack sx={{ mt: 1 }}>
      {widths.map(([n, width]) => (
        <Stack key={n} direction="row" gap={1} sx={{ px: 2, py: 1.5 }}>
          <SvgIcon fontSize="large" color="primary">
            <IconFolder />
          </SvgIcon>
          <Skeleton width={width} />
        </Stack>
      ))}
    </Stack>
  );
};
